
// app
export {default as default, default as app, LudicApp} from './app/app'

// base
export {default as Asset} from './base/asset'
export {default as AssetManager} from './base/assetManager'
export {default as Camera} from './base/camera'
export {default as ImageAsset} from './base/imageAsset'

// canvas
export {default as Canvas} from './canvas/canvas'

// input
export {default as InputController} from './input/inputController'
export {default as GamepadController} from './input/gamepadController'

// patches
/*
  patches that are prototype extensions, just import here
  patches that require a parameter (monkey patch) export function name with prefix `Patch`
    i.e. export {default as PatchFixSomeClass} from './patches/fixSomeClass'
*/
import path2D from './patches/Path2D';
import object from './patches/Object';

// screen
export {default as Screen} from './screen/screen'
export {default as ScreenManager} from './screen/screenManager'

// sprite
export {default as BaseSprite} from './sprite/BaseSprite'
export {default as MultiSprite} from './sprite/MultiSprite'

// ui
// export {default as HUD} from './ui/hud'
// export {default as HUDElement} from './ui/HUDElement'
// export {default as Text} from './ui/Text'
// export {default as Dialog} from './ui/Dialog'
// export {default as MenuDialog} from './ui/MenuDialog'

// util
import * as utils from './utils'
export {utils}

// vectors
export {default as Vector2} from './engine/Vector2'



// WEBPACK FOOTER //
// ./src/main.js